













































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import * as _ from "lodash";
import Button from "@/shared/components/ui/Button.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { PartnerUser, UserRole, PartnerUserRequest, UserPermission } from "@/shared/types";
import { getUserRoleOptions } from "@/shared/components/partners/userRoleOptions";
import PartnerUserAdd from "@/shared/components/partners/PartnerUserAdd.vue";
import PartnerNotificationEmailForm from "@/shared/components/partners/PartnerNotificationEmailForm.vue";
import { Validator } from "vee-validate";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { usePartnerUserStore } from "@/shared/store/partnerUser";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

const UnknownErrorMessage = "Error processing your request. Please try again later";
const initialSearchTerms = {
  firstName: "",
  lastName: "",
  searchEmail: "",
  userRole: UserRole.None
};

@Component({
  components: {
    Button,
    Pagination,
    PartnerUserAdd,
    PartnerNotificationEmailForm
  }
})
export default class PartnerUsers extends Vue {
  $validator: Validator;
  $UserRole = UserRole;

  userStore = useUserStore();
  notifierStore = useNotifierStore();
  partnerUserStore = usePartnerUserStore();
  rolePermissionsStore = useRolePermissionsStore();

  isSubmitting = false;
  searchTerm = { ...initialSearchTerms };
  tableFields = [
    {
      key: "userInfo",
      label: "Name"
    },
    {
      key: "roles",
      label: "Roles and Permissions"
    },
    {
      key: "status",
      label: "Sign-up Status"
    }
  ];
  showConfirmDisableMfaModal = false;
  selectedPartnerUserEmail = "";

  @Prop() partnerId: number;

  @Prop() userPageNumber: number;

  mounted (): void {
    this.searchTerm = {...initialSearchTerms };
    this.partnerUserStore.setPageNumber(this.userPageNumber);
    const request: PartnerUserRequest = {
      partnerId: this.partnerId,
      pageNumber: this.userPageNumber,
      searchFirstname: this.searchTerm.firstName,
      searchLastname: this.searchTerm.lastName,
      searchEmail: this.searchTerm.searchEmail,
      searchRole: this.searchTerm.userRole
    };
    this.partnerUserStore.loadPartnerUsers(request);
  }

  handleError (err) {
    this.notifierStore.setDanger(err.errorMessage || UnknownErrorMessage);
  }

  onPageChanged (pageNumber: number): void {
    this.$router.push(`/partner/${this.partnerId}/users/${pageNumber}`);
  }

  get userRoleOptions () {
    return getUserRoleOptions();
  }

  @Watch("userPageNumber")
  onRouteValuePageNumberChanged () {
    this.partnerUserStore.setPageNumber(this.userPageNumber);
    const request: PartnerUserRequest = {
      partnerId: this.partnerId,
      pageNumber: this.userPageNumber,
      searchFirstname: this.searchTerm.firstName,
      searchLastname: this.searchTerm.lastName,
      searchEmail: this.searchTerm.searchEmail,
      searchRole: this.searchTerm.userRole
    };
    this.partnerUserStore.loadPartnerUsers(request);
  }

  @Watch("partnerId")
  onPartnerIdChange () {
    this.partnerUserStore.setPageNumber(1);
    const request: PartnerUserRequest = {
      partnerId: this.partnerId,
      pageNumber: 1,
      searchFirstname: this.searchTerm.firstName,
      searchLastname: this.searchTerm.lastName,
      searchEmail: this.searchTerm.searchEmail,
      searchRole: this.searchTerm.userRole
    };
    this.partnerUserStore.loadPartnerUsers(request);
  }

  sendActivationLink (inviteId: number) {
    this.partnerUserStore.resendPartnerUserSignupLink(inviteId);
  }

  handleRoleUpdateError (message: string, partnerUser: PartnerUser) {
    delete this.rolesChanging[partnerUser.inviteId];
    this.notifierStore.setDanger(message);
    this.partnerUserStore.updatePartnerUser(partnerUser);
  }

  getMappedRole (role): UserRole {
    switch (role) {
      case "Security":
        return UserRole.SecurityAdmin;
    }
  }
  rolesChanging = [];
  onRoleClicked (partnerUser: PartnerUser, event) {
    const changed = this.getMappedRole(event.target.outerText);
    if (changed === UserRole.SecurityAdmin) {
      const roleIncluded = partnerUser.userRoles.includes(changed);
      if (roleIncluded) {
        if (this.partnerUserStore.numberOfOwners <= 1) {
          this.notifierStore.setDanger("At least one user must have the Security role");
          return event.preventDefault();
        } else {
          this.partnerUserStore.adjustNumberOfOwners(-1);
        }
      } else {
        this.partnerUserStore.adjustNumberOfOwners(1);
      }
    }
    this.rolesChanging[partnerUser.inviteId] = partnerUser;
  }

  debouncedRoleChange = [];
  handleRoleChange (partnerUser) {
    this.partnerUserStore.updatePartnerUser(partnerUser);

    if (!this.debouncedRoleChange[partnerUser.inviteId]) {
      this.debouncedRoleChange[partnerUser.inviteId] = _.debounce(partnerUser => this.onRoleChange(partnerUser), 1000);
    }
    this.debouncedRoleChange[partnerUser.inviteId](partnerUser);
  }

  onRoleChange (partnerUser): void {
    delete this.debouncedRoleChange[partnerUser.inviteId];
    this.partnerUserStore.partnerUserSave({
        partnerId: this.partnerId,
        partnerUser
      }).then((userSave: any) => {
        if (userSave.error) {
          this.handleRoleUpdateError(userSave.error, this.rolesChanging[partnerUser.inviteId]);
        } else {
          this.notifierStore.setSuccess("Partner user roles saved");
        }
      }).catch(err => {
        this.handleRoleUpdateError("Could not save user roles", this.rolesChanging[partnerUser.inviteId]);
      });
  }
  get isFormValid () {
      return !this.$validator.errors.any();
  }

  get isSearchDisabled () {
      return this.isSubmitting === true || !this.isFormValid;
  }

  get isClearDisabled () {
      return this.isSubmitting === true;
  }

  onSearch (): void {
    if (this.isSubmitting) return;
    this.$validator
      .validate()
      .then(result => {
        if (!result) return;
        this.isSubmitting = true;
        if (this.userPageNumber > 1) {
          return this.onPageChanged(1);
        }
        const request: PartnerUserRequest = {
          partnerId: this.partnerId,
          pageNumber: 1,
          searchFirstname: this.searchTerm.firstName,
          searchLastname: this.searchTerm.lastName,
          searchEmail: this.searchTerm.searchEmail,
          searchRole: this.searchTerm.userRole
        };
        this.partnerUserStore.loadPartnerUsers(request);
      }).finally(() => this.isSubmitting = false);
    }
  clearSearch (): void {
    if (!this.isSubmitting) {
      this.searchTerm = { ...initialSearchTerms };
      if (this.userPageNumber > 1) {
          return this.onPageChanged(1);
      }
      this.isSubmitting = true;
      const request: PartnerUserRequest = {
          partnerId: this.partnerId,
          pageNumber: 1,
          searchFirstname: this.searchTerm.firstName,
          searchLastname: this.searchTerm.lastName,
          searchEmail: this.searchTerm.searchEmail,
          searchRole: this.searchTerm.userRole
        };
      this.partnerUserStore.loadPartnerUsers(request);
      this.isSubmitting = false;
    }
  }

  resetPassword (email: string) {
    this.partnerUserStore.sendForgotPasswordLink({ partnerId: this.partnerId, email });
  }

  showConfirmDisableMfa (email) {
    this.showConfirmDisableMfaModal = true;
    this.selectedPartnerUserEmail = email;
  }

  closeDisableMfaModal () {
    this.showConfirmDisableMfaModal = false;
    this.selectedPartnerUserEmail = "";
  }

  confirmDisableMfa (email) {
    this.partnerUserStore.sendDisableMfaLink({ partnerId: this.partnerId, email });
    this.closeDisableMfaModal();
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
  }

  get hasViewPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit) ||
        this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerView);
  }
}
